var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { space } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import { Box } from '../Box';
import { getPaletteColor } from '../utils';
var propTypes = __assign(__assign({}, space.propTypes), { borderColor: PropTypes.string });
var InputGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", " ", " & > ", " {\n    width: 100%;\n    flex: 1 1 auto;\n  }\n\n  & input {\n    border: 0;\n    box-shadow: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", " ", " & > ", " {\n    width: 100%;\n    flex: 1 1 auto;\n  }\n\n  & input {\n    border: 0;\n    box-shadow: none;\n  }\n"])), themeGet('radius'), function (props) { return getPaletteColor(props.borderColor, 'base')(props); }, space, Box);
InputGroup.propTypes = propTypes;
InputGroup.defaultProps = {
    borderColor: 'border',
};
export default InputGroup;
var templateObject_1;
//# sourceMappingURL=InputGroup.js.map